/**
 * Fase 6.1 — gedeelde helper voor de weergavenaam van verwijderde medewerkers.
 * Backend levert canonical `deleted: true` op de user; frontend rendert lokaal
 * de gelokaliseerde fallback. Historische data (server-side geanonimiseerde
 * naam "Verwijderde medewerker") mag als backup blijven staan, maar de UI
 * mag daar NIET afhankelijk van zijn.
 */
export function displayEmployeeName(record, t, opts = {}) {
  if (!record) return opts.dash === false ? "" : "—";
  // A joined user object carries `deleted: true`, standalone rows sometimes
  // just have `employee_deleted` or a null `employee_name` — support all.
  const isDeleted = record.deleted === true || record.employee_deleted === true;
  if (isDeleted) return t("deleted_employee");
  return record.employee_name || record.name || (opts.dash === false ? "" : "—");
}
